import React, { Component } from 'react';
import Session from './Session';

export class Logout extends Component {
    static displayName = Logout.name;

    componentDidMount() {
        // 1) Clear session
        Session.removeUserSession();

        // 2) Hard navigate so header/menu re-mounts and "Hello/Logout" disappears
        window.location.replace('/login');
    }

    render() {
        return null;
    }
}